(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["colette-offers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('colette-offers')) {
    class ColetteOffers extends HTMLElement {
      connectedCallback() {
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        this.colorIndex = Number(this.dataset.colorIndex);
        this.sizeIndex = Number(this.dataset.sizeIndex);
        this.addEventListener('change', (event) => {
          if (event.target.name && event.target.name.startsWith('colette-offer')) this.select();
          if (event.target.matches('[data-size]')) this.syncSizes(event.target);
          if (event.target.matches('[data-color]')) this.showColor(event.target);
        });
        this.querySelector('[data-submit]').addEventListener('click', () => this.submit());
      }

      get selected() {
        return this.querySelector('.colette-offer input:checked')?.closest('.colette-offer');
      }

      select() {
        this.querySelectorAll('.colette-offer').forEach((offer) => {
          const on = offer === this.selected;
          offer.classList.toggle('is-selected', on);
          offer.querySelector('.colette-offer__rows').hidden = !on;
        });
        this.showError('');
      }

      // Picking a size on the first row fills the rows that are still empty.
      syncSizes(select) {
        const rows = [...select.closest('.colette-offer__rows').querySelectorAll('[data-size]')];
        if (rows[0] !== select) return;
        rows.slice(1).forEach((other) => { if (!other.value) other.value = select.value; });
      }

      // Shows the photo of the chosen colour next to its row and in the main gallery.
      showColor(select) {
        const variant = this.variants.find((v) => v.options[this.colorIndex] === select.value && v.image);
        if (!variant) return;
        const thumb = select.closest('[data-row]').querySelector('.colette-offer__row-thumb img');
        if (thumb) {
          thumb.removeAttribute('srcset');
          thumb.src = variant.image;
        }
        const main = this.closest('.cc-buybox')?.querySelector('[data-cc-main]');
        if (main) {
          main.removeAttribute('srcset');
          main.src = variant.imageLarge;
        }
      }

      showError(message) {
        const error = this.querySelector('[data-error]');
        error.textContent = message;
        error.hidden = !message;
      }

      async submit() {
        const offer = this.selected;
        if (!offer) return;
        const counts = new Map();
        for (const row of offer.querySelectorAll('[data-row]')) {
          const color = row.querySelector('[data-color]').value;
          const size = row.querySelector('[data-size]').value;
          if (!size) return this.showError('Choisissez une taille pour chaque débardeur.');
          const variant = this.variants.find(
            (v) => v.options[this.colorIndex] === color && v.options[this.sizeIndex] === size
          );
          if (!variant || !variant.available) {
            return this.showError(`${color} en ${size} n'est pas disponible. Choisissez une autre couleur ou taille.`);
          }
          counts.set(variant.id, (counts.get(variant.id) || 0) + 1);
        }

        const button = this.querySelector('[data-submit]');
        button.setAttribute('aria-busy', 'true');
        this.showError('');
        const root = window.Shopify?.routes?.root || '/';
        const items = [...counts].map(([id, quantity]) => ({ id, quantity }));
        const drawer = this.dataset.redirect === 'drawer' ? document.querySelector('theme-drawer#cart-drawer') : null;
        try {
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(drawer ? { items, sections: 'cart-drawer-section' } : { items }),
          });
          if (!response.ok) throw new Error('add failed');
          if (drawer) {
            await this.openDrawer(drawer, items, await response.json(), root);
            button.removeAttribute('aria-busy');
            return;
          }
          window.location.href = this.dataset.redirect === 'cart' ? `${root}cart` : `${root}checkout`;
        } catch (error) {
          button.removeAttribute('aria-busy');
          this.showError("Impossible d'ajouter au panier pour le moment. Réessayez.");
        }
      }

      // Hands the fresh drawer markup to Horizon's cart flow (CartLinesUpdateEvent), then opens the drawer.
      async openDrawer(drawer, items, addResponse, root) {
        try {
          const { CartLinesUpdateEvent } = await import('@shopify/events');
          const deferred = CartLinesUpdateEvent.createPromise();
          this.dispatchEvent(
            new CartLinesUpdateEvent({
              action: 'add',
              context: 'product',
              lines: items.map((item) => ({ merchandiseId: String(item.id), quantity: item.quantity })),
              promise: deferred.promise,
            })
          );
          const ajaxCart = await fetch(`${root}cart.js`).then((response) => response.json());
          deferred.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
            detail: { items: ajaxCart.items, source: 'colette-offers', sections: addResponse.sections, didError: false },
          });
          await deferred.promise;
          // Horizon's empty → filled drawer transition can skip the morph; render the fresh markup directly then.
          await new Promise((resolve) => requestAnimationFrame(resolve));
          const html = addResponse.sections?.['cart-drawer-section'];
          if (html && drawer.querySelector('.cart-drawer--empty')) {
            const { morphSection } = await import('@theme/section-renderer');
            await morphSection('cart-drawer-section', html, { mode: 'hydration', injectStylesheet: true });
          }
          drawer.open();
        } catch (error) {
          window.location.href = `${root}cart`;
        }
      }
    }
    customElements.define('colette-offers', ColetteOffers);
  }
  } catch(e) { console.error(e); }
})();

})();
